import { ModuleConfig } from '@/core/module';
import { branchManagementRoutes } from './routes';

export const BranchManagementModule: ModuleConfig = {
    name: 'branch-management',
    routes: branchManagementRoutes,
    initialize: () => {
        console.log('Branch Management module initialized');
    },
};
